"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
const react_1 = require("react");
const cs_1 = __importDefault(require("date-fns/locale/cs"));
const de_1 = __importDefault(require("date-fns/locale/de"));
const en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
const sk_1 = __importDefault(require("date-fns/locale/sk"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const local_storage_hook_1 = require("../../utils/local-storage-hook");
const locale_api_1 = require("./locale-api");
const locale_types_1 = require("./locale-types");
function useLocale(props) {
    const [localeName, setLocaleName] = (0, local_storage_hook_1.useLocalStorage)('localeName', props.defaultLocale);
    const [messages, setMessages] = (0, react_1.useState)({});
    const switchLocale = (0, event_callback_hook_1.useEventCallback)(async (localeName) => {
        setLocaleName(localeName);
    });
    const loadTranslations = (0, event_callback_hook_1.useEventCallback)(async (lang) => {
        if (props.messages && props.messages[lang]) {
            setMessages(props.messages[lang]);
        }
        else if (props.translationsUrl) {
            const fetch = (0, locale_api_1.callLoadTranslations)(props.translationsUrl, lang);
            const response = await fetch.response;
            if (response.status === 200) {
                const messages = await response.json();
                setMessages(messages);
            }
            else {
                setMessages({});
            }
        }
    });
    const refreshTranslations = (0, event_callback_hook_1.useEventCallback)(async () => {
        await loadTranslations(localeMap[localeName].easLanguage);
    });
    (0, react_1.useEffect)(() => {
        loadTranslations(localeMap[localeName].easLanguage);
    }, [loadTranslations, localeName]);
    const context = (0, react_1.useMemo)(() => ({
        locale: localeMap[localeName],
        messages,
        switchLocale,
        refresh: refreshTranslations,
    }), [localeName, messages, switchLocale, refreshTranslations]);
    return { context };
}
exports.useLocale = useLocale;
const localeMap = {
    [locale_types_1.LocaleName.cs]: {
        name: 'cs',
        dateFormat: 'dd.MM.yyyy',
        dateTimeFormat: 'dd.MM.yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        shortTimeFormat: 'HH:mm',
        dateFnsLocale: cs_1.default,
        intlLocale: 'cs',
        easLanguage: 'CZECH',
        decimalSeparator: ',',
    },
    [locale_types_1.LocaleName.en]: {
        name: 'en',
        dateFormat: 'dd/MM/yyyy',
        dateTimeFormat: 'dd/MM/yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        shortTimeFormat: 'HH:mm',
        dateFnsLocale: en_GB_1.default,
        intlLocale: 'en',
        easLanguage: 'ENGLISH',
        decimalSeparator: '.',
    },
    [locale_types_1.LocaleName.de]: {
        name: 'de',
        dateFormat: 'dd.MM.yyyy',
        dateTimeFormat: 'dd.MM.yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        shortTimeFormat: 'HH:mm',
        dateFnsLocale: de_1.default,
        intlLocale: 'de',
        easLanguage: 'GERMAN',
        decimalSeparator: ',',
    },
    [locale_types_1.LocaleName.sk]: {
        name: 'sk',
        dateFormat: 'dd.MM.yyyy',
        dateTimeFormat: 'dd.MM.yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        shortTimeFormat: 'HH:mm',
        dateFnsLocale: sk_1.default,
        intlLocale: 'sk',
        easLanguage: 'SLOVAK',
        decimalSeparator: ',',
    },
};
//# sourceMappingURL=locale-hook.js.map